/**
 * all states from store
 */
export default {
  missions: null,
  subs_last: 1,
  not_subs_missions: null,
  not_subs_last: 1,
  finished_last: 1,
  mission: null,
  subs_questions: {},
  finished_missions: null,
  finished_details: {},
  public_missions: {},
  public_finished: {},
  show_public_mission: {},
  public_header: [],
  mission_terms: {},
  avaible_missions: [],
  temporary_upload_links: {},
  tab_active: "notEnrolled", // "notEnrolled", "inProgress", "finished"
  tabs: {
    suspense: {
      notEnrolled: {
        key: 0
      },
      inProgress: {
        key: 1
      },
      finished: {
        key: 2
      }
    }
  }
};
